import { FC, memo, useEffect, useMemo, useRef, useState } from 'react';
import { getAssetUrl } from '@/utils/common';
import { qrCodeList } from './instance';
import styles from './index.module.scss';
import { useXAgentClient } from '@shuwen/wenlv-web-activity-library';

interface Props {
  name?: string;
}

const QrCode: FC<Props> = ({ name = '杭州西湖地图页' }) => {
  const iconRef = useRef<HTMLImageElement>(null);
  const [showCode, setShowCode] = useState(false);

  const {deviceInfo} = useXAgentClient();
  const isXihuCitywalk = useMemo(() => {
    return deviceInfo?.exhibitionConfigInfo?.isXihuCitywalk;
  }, [deviceInfo]);

  const codeImg = useMemo(() => {
    return qrCodeList.find(i => i.name === name)?.url;
  }, [name]);

  const codeIconUrl = useMemo(() => {
    return getAssetUrl(isXihuCitywalk ? 'images/landmark/codeIcon1.png' : 'images/landmark/codeIcon.png');
  }, [isXihuCitywalk]);

  useEffect(() => {
    const img = new Image();
    img.src = codeIconUrl;
    img.onload = () => {
      setShowCode(true);
    }
  }, []);

  return (
    <div>
      {
        showCode ?
          <div className={styles.qrCode}>
            <div className={styles.imgWrap}>
              <img src={codeIconUrl} className={styles.codeIcon} ref={iconRef} />
              <img src={codeImg} className={styles.code} />
              <img src={getAssetUrl('images/route/timeLine/codeLabel.svg')} className={styles.label} />
            </div>
            {/* <div className={styles.label}>微信扫码 开启壮游</div> */}
          </div> :
          null
      }
    </div>
  )
}

export default memo(QrCode);
